import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';

import { useRequestData } from 'wsm-common-data';
import { isBrowser } from 'ws-scripts/modules/environment';
import { trackEvent } from 'ddc-track-event';
import Skeleton from 'wsm-skeleton';
import { setClassNames } from 'ddc-classnames-js';

import { getVehicleObj } from '../../../utilities/vehicleTracking';

const LazyCarousel = lazy(() =>
	import(
		/* webpackChunkName: 'new-media-focused-carousel' */ 'wsm-vehicle-media-gallery'
	).then((module) => ({
		default: module.MediaFocusedCarousel
	}))
);

const MediaFocusedCarouselContainer = ({
	shouldFullyRenderCard,
	images = [],
	link,
	uuid
}) => {
	const { widgetName, windowId } = useRequestData();

	const trackInteraction = (direction) => {
		trackEvent(widgetName, windowId, {
			element: `Photo carousel ${direction} button`,
			result: `Move to ${direction} slide`,
			uuid,
			vehicle: getVehicleObj(uuid)
		});
	};

	return (
		<div
			className={setClassNames([
				'vehicle-card-media-container',
				'p-3',
				!shouldFullyRenderCard && 'm-0'
			])}
		>
			{shouldFullyRenderCard && isBrowser ? (
				<Suspense
					fallback={
						<Skeleton
							skeletonClasses="mb-4"
							aspectRatio="4by3"
							dataTestId="media-skeleton-loading"
						/>
					}
				>
					<LazyCarousel
						images={images}
						// TODO: add to module
						onNextClick={() => trackInteraction('next')}
						onPrevClick={() => trackInteraction('previous')}
						link={link}
						uuid={uuid}
					/>
				</Suspense>
			) : (
				<Skeleton
					skeletonClasses="mb-4"
					aspectRatio="4by3"
					dataTestId="media-skeleton"
				/>
			)}
		</div>
	);
};

MediaFocusedCarouselContainer.propTypes = {
	shouldFullyRenderCard: PropTypes.bool,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			alt: PropTypes.string,
			id: PropTypes.string,
			provider: PropTypes.string,
			title: PropTypes.string,
			uri: PropTypes.string
		})
	),
	link: PropTypes.string,
	uuid: PropTypes.string.isRequired
};

export default MediaFocusedCarouselContainer;
